var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('TableRender',{attrs:{"Service":_vm.Service,"align":"center"}},[_c('TableAction',{attrs:{"buttons":[
    { name: '编辑' },
    { name: '删除' }
  ],"minWidth":250}}),_c(_vm.current,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }